import { useQuery } from '@tanstack/react-query'
import { api } from './client'
import type { FamilyCard } from '../../../backend/src/modules/family-economics/types'
export type { FamilyCard }
export interface FamilyFilters { profileId: number; periodFrom: string; periodTo: string }
export async function getFamilyCard(filters: FamilyFilters, signal?: AbortSignal): Promise<{ card: FamilyCard }> {
  const query = new URLSearchParams({ profileId: String(filters.profileId), periodFrom: filters.periodFrom, periodTo: filters.periodTo })
  return api.get<{ card: FamilyCard }>(`/family-economics/card/?${query}`, { signal })
}
export function useFamilyCard(filters: FamilyFilters) {
  return useQuery({
    queryKey: ['family-economics', filters], queryFn: ({ signal }) => getFamilyCard(filters, signal),
    enabled: filters.profileId > 0 && !!filters.periodFrom && !!filters.periodTo && filters.periodFrom <= filters.periodTo,
    retry: false,
  })
}
